export enum CurrencySymbol {
    Unknown = '',
    Gbp = '£',
}